export const Theme = {
  color: {
    background: '#EFEFFF',
    neutral: {
      white: '#FFF',
      gray: '#494949',
      black: '#000',
      background: '#F5F5F5',
    },
    green: {
      green: '#00A324',
    },
    blue: {
      base: '#067FB7',
      blue50: '#EDF4FC',
      blue100: '#C8E0F7',
      blue200: '#A3CBEF',
      blue300: '#7DB6E5',
      blue400: '#58A2D7',
      blue500: '#308EC6',
      blue600: '#0079B1',
      blue700: '#006598',
      blue800: '#00517D',
      blue900: '#003E5F',
    },
    purple: {
      base: '#150D49',
      purple50: '#F6F2FC',
      purple100: '#E3D8F6',
      purple200: '#CFBFEE',
      purple300: '#BBA7E3',
      purple400: '#A690D5',
      purple500: '#907AC3',
      purple600: '#7B66AE',
      purple700: '#665396',
      purple800: '#52427B',
      purple900: '#3E325E',
    },
    red: {
      base: '#BB0000',
      red50: '#FFEEE7',
      red100: '#FFCCB9',
      red200: '#FFAA8E',
      red300: '#FF8868',
      red400: '#FF6848',
      red500: '#F14A2D',
      red600: '#D92F18',
      red700: '#BB1809',
      red800: '#9A0A02',
      red900: '#770A00',
    },
  },
  border: {
    radius: '8px',
  },
  font: {
    text8xl: '96px',
    text6xl: '56px',
    text5xl: '48px',
    text4xl: '34px',
    text2xl: '24px',
    textxl: '20px',
    textbase: '16px',
    textsm: '14px',
    textcaption: '12px',
    textoverline: '10px',
  },
} as const
